import { useParams } from 'react-router-dom';
import Loading from '@/components/general/Loading';
import useApiFetch from '@/hooks/useApiFetch';
import CheckinDetailsPage from '@/pages/CheckinDetails';
import UserCurrentCheckinPage from '@/pages/UserCurrentCheckin';
import checkinReports from '@/services/checkinReports';
import { FetchApiIds } from '@/types';
import { UserCheckin } from '@/types/api';

const CheckinManager = function (): JSX.Element {
  const { checkinId } = useParams();

  const currentCheckinResponse = useApiFetch<UserCheckin>(
    [FetchApiIds.CHECKIN_BY_ID, checkinId],
    async () => checkinReports.getCheckinById({ checkinId: checkinId as string })
  );

  if (currentCheckinResponse.isLoading) {
    return <Loading />;
  }
  if (!currentCheckinResponse.data?.answeredAt) {
    return <UserCurrentCheckinPage />;
  }

  return <CheckinDetailsPage />;
};

export default CheckinManager;
